<div class="main-declare">
    <div class="container  " *ngIf="locationIsAllowed">
        
        <div class="text-center">
            <img src="https://firebasestorage.googleapis.com/v0/b/covid-19-tn.appspot.com/o/assets%2Fillustration-01.png?alt=media&token=ba5e749a-852c-4c81-b25b-d0f2f5bdaf92" class="top-title">
        </div>
        <h4 class="text-center"> <i class="fas fa-medkit"></i> JE PENSE QUE JE SUIS MALADE <i class="fas fa-medkit"></i></h4>
        <hr/>
        <diV class="call-for-help">
            <form [formGroup]="declaration" (ngSubmit)="sendDeclaration($event)">
    
    
                <div class="form-group">
                  <label ><i class="fas fa-user-alt"></i> PRÉNOM ET NOM ( الاسم واللقب )</label>
                  <input type="text" class="form-control"  placeholder="PRÉNOM ET NOM" name="fullname" formControlName="fullname" >
                </div>
                <div class="form-group">
                    <label ><i class="fas fa-phone-square-alt"></i> TÉLÉPHONE ( رقم الهاتف )</label>
                    <input type="text" class="form-control"  placeholder="TÉLÉPHONE" name="phone" formControlName="phone" >
                </div>
                <div class="form-group">
                    <label ><i class="fas fa-arrow-location"></i> RÉGION ( المنطقة )</label>
                    <select class="form-control" name="region" formControlName="region">
                        <option value="Ariana - أريانة">Ariana - أريانة</option>
                        <option value="Béja - باجة">Béja - باجة</option>
                        <option value="Ben Arous - بن عروس">Ben Arous - بن عروس</option>
                        <option value="Bizerte - بنزرت">Bizerte - بنزرت</option>
                        <option value="Gabès - قابس">Gabès - قابس</option>
                        <option value="Gafsa - قفصة">Gafsa - قفصة</option>
                        <option value="Kairouan - القيروان">Kairouan - القيروان</option>
                        <option value="Jendouba - جندوبة">Jendouba - جندوبة</option>
                        <option value="Kasserine - القصرين">Kasserine - القصرين</option>
                        <option value="Kébili - قبلي">Kébili - قبلي</option>
                        <option value="Le Kef - الكاف">Le Kef - الكاف</option>
                        <option value="Mahdia - المهدية">Mahdia - المهدية</option>
                        <option value="Manouba - منوبة">Manouba - منوبة"</option>
                        <option value="Médenine - مدنين">Médenine - مدنين</option>
                        <option value="Monastir - المنستير">Monastir - المنستير</option>
                        <option value="Nabeul - نابل">Nabeul - نابل</option>
                        <option value="Sfax - صفاقس">Sfax - صفاقس</option>
                        <option value="Sidi Bouzid - سيدي بوزيد">Sidi Bouzid - سيدي بوزيد</option>
                        <option value="Siliana - سليانة">Siliana - سليانة</option>
                        <option value="Sousse - سوسة">Sousse - سوسة</option>
                        <option value="Tataouine - تطاوين">Tataouine - تطاوين</option>
                        <option value="Tozeur - توزر">Tozeur - توزر</option>
                        <option value="Tunis - تونس">Tunis - تونس</option>
                        <option value="Zaghouan - زغوان">Zaghouan - زغوان</option>

                        
                        
                        
                        
                    </select>
                </div>
                
                <div class="form-group">
                    <label ><i class="fas fa-male"></i> <i class="fas fa-female"></i>  SEXE ( الجنس)</label>
                    <select class="form-control" name="sex" formControlName="sex">
                        <option value="1">HOMME (ذكر)</option>
                        <option value="2">FEMME (أنثى)</option>
                        
                    </select>
                </div>
                <div class="form-group">
                    <label ><i class="fas fa-clock"></i>  ÂGE ( العمر)</label>
                    <input type="text" class="form-control"  placeholder="ÂGE" name="age" formControlName="age" >
                </div>
                
                <hr/>
                <h4>Quels sont les symptômes que vous avez ? <br/> (ما الأعراض التي تعاني منها؟)</h4>
    
                <table class="table ">
                    <tbody class="table-striped">
                        <tr>
                        
                            <td>
                                <label class="form-check-label" for="defaultCheck1">
                                    Une fièvre supérieure à 37,5°C<br/> (حمى فوق 37.5 درجة مئوية)
                                </label>
                            </td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" formControlName="s1">
                            </td>
                        </tr>
        
                        <tr>
                            <td>
                                <label class="form-check-label" for="defaultCheck1">
                                    Des signes respiratoires de type, toux, sensation d'oppression et/ou douleur thoracique, avec parfois dyspnée (essoufflement).
                                    علامات الجهاز التنفسي مثل السعال والضيق و / أو ألم الصدر ، وأحيانًا مع ضيق في التنفس (ضيق في التنفس).
                                </label>
                            </td>
                            <td>
                                <input class="form-check-input" type="checkbox" value="" id="defaultCheck1"  formControlName="s2">
                            </td>
                        </tr>
        
                        <tr>
                            <td>
                                <label class="form-check-label" for="defaultCheck1">
                                    Des frissons. (قشعريرة.)
                                </label>
                            </td>
                            <td>
                                <input class="form-check-input" type="checkbox" value="" id="defaultCheck1"  formControlName="s3">
                            </td>
                        </tr>
                        
                        <tr>
                            <td>
                                <label class="form-check-label" for="defaultCheck1">
                                    Des courbatures. (الأوجاع.)
                                </label>
                            </td>
                            <td>
                                <input class="form-check-input" type="checkbox" value="" id="defaultCheck1"  formControlName="s4">
                            </td>
                        </tr>
        
                        <tr>
                            <td>
                                <label class="form-check-label" for="defaultCheck1">
                                    Une fatigue inhabituelle. (تعب غير عادي.)
                                </label>
                            </td>
                            <td>
                                <input class="form-check-input" type="checkbox" value="" id="defaultCheck1"  formControlName="s5">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label class="form-check-label" for="defaultCheck1">
                                    Des maux de tête. (الصداع.)
                                </label>
                            </td>
                            <td>
                                <input class="form-check-input" type="checkbox" value="" id="defaultCheck1"  formControlName="s6">
                        
                            </td>
                        </tr>
                    </tbody>
                    
                    
    
    
                </table>
    
    
                <p> En appuyant sur Inscription, vous acceptez nos <a routerLink="/termsofuse">conditions d'utilisation.</a></p>
                <button type="submit" class="btn btn-primary"  style="margin-right: 15px;margin-bottom:15px" [disabled]="! declaration.valid" >ENVOYER (إرسال)</button>
                <button type="reset" class="btn btn-secondary" routerLink="/" style="margin-right: 15px;margin-bottom:15px">ANNULER (إلغاء)</button>
                

              </form>
        </diV>
    
    </div>
    
    <div *ngIf="!locationIsAllowed" class="text-center container allow-position">
        <h1><i class="fas fa-location-arrow"></i><br/> Autorisation de localisation</h1>
        <p>Afin d'envoyer une demande d'aide, nous aurons besoin de votre emplacement, pour nous permettre de vous joindre facilement.</p>
        <button class="btn btn-primary btn-sm" (click)="getUserLocation()" style="margin-right: 15px;margin-bottom:15px"  >LOCALISEZ-MOI</button>
        <button type="reset" class="btn btn-secondary btn-sm" routerLink="/" style="margin-right: 15px;margin-bottom:15px" >ANNULER</button>
    </div>
    
    
    <div *ngIf="isLoading " class="loader text-center">
        <img [src]="imgsrc" class="loading-img">
        <h3 class="msg">{{messageLoader}}</h3>
        <button class="btn btn-secondary btn-sm my-2" routerLink="/" *ngIf="requestIsSent">RETOUR À LA CARTE</button>
    </div>
</div>